import Confirm from "../Confirm";
import Modal from "../Modal";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Input from "../Inputs/Input";
import Button from "../Inputs/Button";
import { InvestmentIncome, ScenarioSettings } from "src/types";
import StartEndSelect from "./StartEndSelect";
import { printNumber } from "src/utils";
import { calculateInvestmentSchedule } from "src/calculator/investment-income";
const InvestmentSchedule = ({
  openYears,
  setOpenYears,
  setIncome,
  income,
  settings,
  people,
}: {
  openYears: boolean;
  setOpenYears: (open: boolean) => void;
  setIncome: (income: InvestmentIncome) => void;
  income: InvestmentIncome;
  settings: ScenarioSettings;
  people: any[];
}) => {
  const [resetOpen, setResetOpen] = useState(false);

  const setField = (index: number, field: string, value: any) => {
    const newSchedule = [...income.schedule];
    newSchedule[index] = {
      ...newSchedule[index],
      [field]: value,
    };
    setIncome({ ...income, schedule: newSchedule });
  };

  const schedule = calculateInvestmentSchedule(
    settings,
    income,
    people,
    settings.maxYearsShown + new Date().getFullYear(),
  );

  return (
    <Modal isOpen={openYears} onClose={() => setOpenYears(false)}>
      <div className="w-[1000px]">
        <Confirm
          isOpen={resetOpen}
          onClose={() => setResetOpen(false)}
          onConfirm={() => {
            setIncome({ ...income, schedule: [] });
            setResetOpen(false);
          }}
        >
          Are you sure you want to reset the whole annuity schedule?
        </Confirm>
        <div className="flex justify-center ">
          <div className="mb-4">
            <div className="flex justify-center items-end w-full gap-2">
              <Input
                vertical
                label="Initial Principal"
                labelLength={115}
                subtype="money"
                width="w-[150px]!"
                value={income.principal}
                setValue={(v) => setIncome({ ...income, principal: v })}
              />
              <Input
                vertical
                label="Rate of Return"
                labelLength={110}
                subtype="percent"
                width="w-[110px]!"
                value={income.scheduleIncrease}
                setValue={(v) => setIncome({ ...income, scheduleIncrease: v })}
              />
              <div className="w-[380px]">
                <Button type="secondary" onClick={() => setResetOpen(true)}>
                  Reset Schedule
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-1 mt-5 font-semibold text-lg text-left w-full ">
          Contribution Schedule
        </div>
        <div className=" mt-10 flex flex-col max-h-[970px]  h-[500px] overflow-scroll gap-2 mb-4">
          <table className="border bg-white text-sm! w-full">
            <thead
              className={`text-xs cursor-pointer print:static bg-[#F9FAFB] text-black font-medium text-left sticky z-50 print:border-transparent print:border-b-gray-500 print:border-2 border  border-separate`}
            >
              <tr>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  Start
                </th>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  End
                </th>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  Contribution
                </th>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  Yearly Increase
                </th>
                <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {income.schedule.map((i, index) => (
                <tr
                  className={`${index % 2 == 1 ? "bg-[#F9FAFB]" : "bg-white"} border-y border-[#EAECF0] hover:bg-slate-100`}
                >
                  <td
                    className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                  >
                    <StartEndSelect
                      label=""
                      shownOptions={[
                        ...(income.personId != -1
                          ? [["death", income.personId]]
                          : (people.map((p) => ["death", p.id] as any) as any)),
                        ...(income.personId != -1
                          ? [["age", income.personId]]
                          : (people.map((p) => ["age", p.id] as any) as any)),
                        ["calendar-year"],
                        ["already-contributing"],
                        ["#-of-years"],
                        ...(income.personId != -1
                          ? [["retirement", income.personId]]
                          : (people.map(
                              (p) => ["retirement", p.id] as any,
                            ) as any)),
                      ]}
                      value={i.start}
                      setValue={(start) => setField(index, "start", start)}
                      settings={settings}
                    />
                  </td>
                  <td
                    className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                  >
                    <StartEndSelect
                      label=""
                      shownOptions={[
                        ...(income.personId != -1
                          ? [["death", income.personId]]
                          : (people.map((p) => ["death", p.id] as any) as any)),
                        ...(income.personId != -1
                          ? [["age", income.personId]]
                          : (people.map((p) => ["age", p.id] as any) as any)),
                        ["calendar-year"],
                        ["end-of-plan"],
                        ["#-of-years"],
                        ...(income.personId != -1
                          ? [["retirement", income.personId]]
                          : (people.map(
                              (p) => ["retirement", p.id] as any,
                            ) as any)),
                      ]}
                      value={i.end}
                      setValue={(end) => setField(index, "end", end)}
                      settings={settings}
                    />
                  </td>
                  <td
                    className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                  >
                    <div className="flex  items-center">
                      <Input
                        label={``}
                        subtype="money"
                        onPaste={(_: any) => {}}
                        value={i.amount}
                        width="h-[30px]! text-sm"
                        setValue={(value) => setField(index, "amount", value)}
                      />
                      <div className=" ml-1 w-16">
                        {income.scheduleMoYr === "monthly"
                          ? " / month"
                          : " / year"}
                      </div>
                    </div>
                  </td>
                  <td>
                    <Input
                      label={``}
                      subtype="percent"
                      onPaste={(_: any) => {}}
                      value={i.yearlyIncrease}
                      width="h-[30px]! text-sm"
                      setValue={(value) =>
                        setField(index, "yearlyIncrease", value)
                      }
                    />
                  </td>
                  <td
                    className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                  >
                    <div className="flex  items-center">
                      <Button
                        type="secondary"
                        onClick={() =>
                          setIncome({
                            ...income,
                            schedule: income.schedule.filter(
                              (_, i) => i !== index,
                            ),
                          })
                        }
                      >
                        <div className="flex items-center justify-center">
                          <TrashIcon className="w-5 h-5 " />
                        </div>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="w-32">
            <Button
              type="primary"
              onClick={() =>
                setIncome({
                  ...income,
                  schedule: [
                    ...income.schedule,
                    {
                      start: { type: "already-contributing" },
                      end: { type: "end-of-plan" },
                      amount: null as any,
                      yearlyIncrease: null as any,
                    },
                  ],
                })
              }
            >
              <div className="flex items-center justify-center">
                <PlusIcon className="w-4 h-4 mr-1" />
                Add Stage
              </div>
            </Button>
          </div>

          <div>
            <table className="border bg-white text-sm! w-full mt-6">
              <thead
                className={`text-xs cursor-pointer print:static bg-[#F9FAFB] text-black font-medium  sticky z-50 print:border-transparent print:border-b-gray-500 print:border-2 border  border-separate`}
              >
                <tr>
                  <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                    Year
                  </th>
                  <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                    New Contributions
                  </th>
                  <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                    Return
                  </th>

                  <th className={`px-2 py-[0.45rem] font-medium text-black`}>
                    End Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {schedule.map((item, index) => (
                  <tr
                    className={`${index % 2 == 1 ? "bg-[#F9FAFB]" : "bg-white"} border-y border-[#EAECF0] hover:bg-slate-100`}
                  >
                    <td
                      className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                    >
                      {item.year}
                    </td>
                    <td
                      className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                    >
                      {printNumber(item.newInvestment)}
                    </td>
                    <td
                      className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                    >
                      {printNumber(item.return)}
                    </td>

                    <td
                      className={`px-2 print:py-[0.2rem] py-[0.45rem] text-[#475467]
                              `}
                    >
                      {printNumber(item.endAmount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InvestmentSchedule;
